// @flow

import { css } from 'styled-components';
import type {
  Theme,
  ACFRowTemplate,
  ACFCut,
} from '../../../types';
import media from '../../../helpers/media';
import { breakpointKeys } from '../../../helpers/breakpoints';
import { getValueOrArrayHead } from '../../../helpers';
import { getBackgroundImage } from './getBackgroundImage';
import { getDefaultYPadding } from './getDefaultYpadding';
import { getPaddingBottom } from './getPaddingBottom';
import { getMinimalColumnHeight } from './getMinimalColumnHeight';
import type { BreakpointData } from '../../row/types';
import type { ColumnImage } from '../types';

export const getColumnStyling = (
  rowTemplate: ACFRowTemplate,
  cut: ACFCut,
  responsiveData: BreakpointData,
  image: ?ColumnImage,
  componentsOverCut: boolean,
  theme: Theme,
) => {
  if (!responsiveData) { return null }

  const padding = getDefaultYPadding(rowTemplate, theme);
  const cutPadding = cut !== 'default' ? '6vw' : '0px';

  return css`
    ${image && image.use_image && css`
      background-image: url(${getBackgroundImage(image.image, 'default')});
      background-position: ${getValueOrArrayHead(image.position_vertical)} ${getValueOrArrayHead(image.position_horizontal)};
      background-repeat: no-repeat;
      min-height: ${getMinimalColumnHeight(image.image, 'default', padding)};
    `}

    display: ${responsiveData.default.hidden ? 'none' : 'flex'};
    padding-top: ${responsiveData.default.hasTop ? padding : theme.column.padding};
    padding-bottom: ${getPaddingBottom(responsiveData, padding, cutPadding, 'default', image, rowTemplate, cut, componentsOverCut, theme)};

    ${breakpointKeys.map(breakpoint => media[breakpoint](css`
      ${image && image.use_image && css`
        background-image: url(${getBackgroundImage(image.image, breakpoint)});
        min-height: ${getMinimalColumnHeight(image.image, breakpoint, padding)};
      `}

      display: ${responsiveData[breakpoint].hidden ? 'none' : 'flex'};
      padding-top: ${responsiveData[breakpoint].hasTop ? padding : theme.column.padding};
      padding-bottom: ${getPaddingBottom(responsiveData, padding, cutPadding, breakpoint, image, rowTemplate, cut, componentsOverCut, theme)};
    `))};
  `;
};

export default null;
